@if (addressForm && !verifyAddressModel) {
  <form [formGroup]="addressForm" autocomplete="off">
    <div class="content-container form-comp mb-3">
      <div class="title" [ngClass]="lastUpdatedOn? 'd-flex justify-content-between' : ''">
        <mwp-text-translate text="{{title}}" jsonKey="{{title}}" />
      </div>
      <div class="content">
        <div class="row">
          @if (errorMessage) {
            <div class="col-12 mb-3">
              <div class="message-container error">
                {{errorMessage}}
              </div>
            </div>
          }
          @if (isDenied) {
            <div class="col-12 mb-3">
              <div class="message-container blue-fill">
                <mwp-text-translate text="Denied Reason" jsonKey="eeniedReason" />: {{deniedReason}}
              </div>
            </div>
          }
          @if (lastUpdatedOn) {
            <div class="col-12 mb-3">
              <mwp-text-translate text="Last Updated" jsonKey="lastUpdated" />: {{lastUpdatedOn}}
            </div>
          }
          <div class=" col-4 mb-4">
            <mwp-input [form]="addressForm" labelName="Address 1" nameForControl="addressOne" />
          </div>
          <div class="col-4 mb-4">
            <mwp-input [form]="addressForm" labelName="Address 2" nameForControl="addressTwo" />
          </div>
          <div class="col-4 mb-4">
            <mwp-input [form]="addressForm" labelName="City" nameForControl="city" />
          </div>
          <div class="col-4 mb-4">
            <mwp-dropdown-enum [form]="addressForm" labelName="State" nameForControl="homeState" [dataEnum]="usStates" [autoTranslate]="true" />
          </div>
          <div class="col-4 mb-4">
            <mwp-input [form]="addressForm" labelName="Zip Code" nameForControl="zipCode" [maskType]="maskType.zipCode" />
          </div>
        </div>
      </div>
      @if (isEditing) {
        <div class="footer">
          <div class="d-flex justify-content-end">
            <button class="mwp-button-secondary" (click)="cancel()">
              <mwp-text-translate text="Cancel" jsonKey="cancel" />
            </button>
            <button class="mwp-button-save ms-3" [disabled]="!addressForm.valid" (click)="verify()">
              <mwp-text-translate text="Verify Address" jsonKey="verifyAddress" />
            </button>
          </div>
        </div>
      }
    </div>
  </form>
}
@if (verifyAddressModel) {
  <div class="content-container form-comp mb-3">
    <div class="title">
      <mwp-text-translate text="{{verifyTitle}}" jsonKey="{{verifyTitle}}" />
    </div>
    <div class="content pt-0">
      <div class="row">
        <div class="col-6 split-border-left py-3">
          <div class="fw-bold mb-3">
            <mwp-text-translate text="What you entered" jsonKey="whatYouEntered" />
          </div>
          <div>
            {{verifyAddressModel.address1}}
          </div>
          <div>
            {{verifyAddressModel.address2}}
          </div>
          <div>
            {{verifyAddressModel.city}}, {{verifyAddressModel.state}} {{verifyAddressModel.zipCode}}
          </div>
        </div>
        <div class="col-6 py-3">
          <div class="fw-bold mb-3">
            <mwp-text-translate text="Updated To" jsonKey="updatedTo" />
          </div>
          <div>
            {{verifyAddressModel.address1Verified}}
          </div>
          <div>
            {{verifyAddressModel.address2Verified}}
          </div>
          <div>
            {{verifyAddressModel.cityVerified}}, {{verifyAddressModel.stateVerified}} {{verifyAddressModel.zipVerified}}
          </div>
        </div>
      </div>
    </div>
    @if (isEditing) {
      <div class="footer">
        <div class="d-flex justify-content-end">
          <button class="mwp-button-secondary" (click)="cancel()">
            <mwp-text-translate text="cancel" jsonKey="Cancel" />
          </button>
          <button class="mwp-button-red mx-3" (click)="resetVerify()">
            <mwp-text-translate text="Make Address Changes" jsonKey="makeAddressChanges" />
          </button>
          <button class="mwp-button-save mx-3" (click)="save()">
            <mwp-text-translate text="Submit Address Chnage Request" jsonKey="submitAddressChnageRequest" />
          </button>
        </div>
      </div>
    }
  </div>
}